import { gql } from '@apollo/client'

export const GET_TERRITORY_TOTAL_POSTS = gql`
  query getTerritoryTotalPosts($territoryId: ID!, $timeRange: TimeRange) {
    getTerritory(territoryId: $territoryId) {
      territoryId
      territoryPerformance {
        totalPosts(timeRange: $timeRange)
      }
    }
  }
`
